<template>
    <component :is="callForFundsView" />
</template>

<script>

import defaultView from './callForFunds/_default.vue';
import lamotteView from './callForFunds/lamotte.vue';

export default {
    name: 'CallForFunds',

    computed: {
        callForFundsView() {
            if (this.$store.state.application.providerCode === 'lamotte') {
                return lamotteView;
            }

            return defaultView;
        }
    }
};
</script>
